import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { AuthLayout } from 'shared/layout'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useReCaptchaContext } from 'entities/Auth'
import { LoginStore } from 'pages/auth/pages/login/ui/Login/store/loginStore'
import { LoginForm } from 'pages/auth/pages/login/ui/Login/ui/LoginForm/LoginForm'
import styles from './styles.module.scss'

export const Login = observer(() => {
  const entities = useEntitiesContext()
  const storeReCaptchaContext = useReCaptchaContext()
  const [store] = useState(() => new LoginStore(entities, storeReCaptchaContext))

  useEffect(() => {
    store.init()

    if (window.sessionStorage.getItem('expire_time_session')) {
      store.setAlertWarning('Session timed out for security reasons. Please sign in again.')

      window.sessionStorage.removeItem('expire_time_session')
    }

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <div className={styles.wrap}>
      <AuthLayout
        title='Sign in to Salesmsg'
        form={<LoginForm store={store} />}
        formClassnames={styles.form}
      />
    </div>
  )
})

export default Login
